import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { BaseService } from "../../services/base.service";
import { SharedService } from "../../services/shared.service";
import * as config from '../../config/app.config';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {
  b2bUnitID: any;

  userAccountData:any;
  public userAccountDetails = new BehaviorSubject<any>(false);
  public userAccountDetails$ = this.userAccountDetails.asObservable();

  public editCancelFluPaymentMethodDtls = new Subject<any>();
  
  constructor(private readonly baseService: BaseService,
            private readonly sharedService:SharedService) {

    this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => { 
      this.b2bUnitID = res?.defaultB2BUnit?.uid;
     });
  }

  public getAllPaymentMethods(params){
    return this.baseService.get(config.GET_PRACTICEORFACILITYTYPE, params)
  }

  public getUserAccountDataFromDb(userId): void {
    this.userAccountData = new Subject<any>();
    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/`, { fields: 'FULL' })
      .subscribe((res) => {
        if (res!==null && res!==undefined && res?.length!==0) {
          this.userAccountData.next({ res });
        }
      });
  }

  public getUserAccountDetailsDataFromDb(userId,accountId): void { 
    this.baseService
      .get(`${config.USER_ACCOUNT}${userId}/b2bUnits/${accountId}`, { fields: 'FULL' })
      .subscribe((res) => {
        if (res!==null && res!==undefined && res?.length!==0) {
          this.userAccountDetails.next({ res });
        }
      });
  }
}
